import { render, staticRenderFns } from "./PrimeryKotelnyh.vue?vue&type=template&id=cd1a78c6&scoped=true"
import script from "./PrimeryKotelnyh.vue?vue&type=script&lang=js"
export * from "./PrimeryKotelnyh.vue?vue&type=script&lang=js"
import style0 from "./PrimeryKotelnyh.vue?vue&type=style&index=0&id=cd1a78c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1a78c6",
  null
  
)

export default component.exports